import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Skeleton, SkeletonCircle, SkeletonText } from '@chakra-ui/react';
import { gql, useQuery } from '@apollo/client';
import { InitSwAuth } from '@skill-wallet/auth';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { RecommendedUsers } from '../components';
import AppContext from '../context/AppContext';

import { pageAnimation } from '../animation';
import postApi from '../api/post';
import useApi from '../hooks/useApi';

import defPic from '../assets/images/bg.jpg';
export default function Dao() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    currentAccount,
    theme,
    isLoggedIn,
    isMember,
    hasLoaded,
    accountDetails,
    setSideNav,
    sideNav,
  } = useContext(AppContext);

  useEffect(() => {
    if (hasLoaded) {
      if (!isLoggedIn) {
        navigate('/connect');
      } else if (!isMember) {
        navigate('/create-profile');
      } else {
      }
    }
  }, [isMember, isLoggedIn, hasLoaded]);
  let COVALENT_KEY = 'ckey_9ebee12fd55e4e05b33496e5c7e';
  let data;
  const getData = async () => {
    try {
      data = await axios.get(
        `https://api.covalenthq.com/v1/80001/events/address/0xfb19708dEc0c84b739F98D9AAAE719D236Af3B32/?quote-currency=USD&format=JSON&starting-block=12115107&ending-block=12240004&key=${COVALENT_KEY}`
      );
    } catch (error) {
      console.log(error);
    }
    console.log('THIS IS THE COVALENT DATA', data);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <StyledDao
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      theme_={theme}
    >
      <>
        <div className="left">
          <div className="body">
            <div className="header">
              <span className="dp" onClick={() => setSideNav(!sideNav)}>
                <img src={accountDetails?.picture?.original?.url || defPic} />
              </span>
              <span>
                <h3>DAO (Sponsored by Skill wallet)</h3>
              </span>
            </div>
            <div className="dao-cont">
              <h3>Connect to VoiceDAO </h3>
              <sw-auth
                partner-key="5c52449d616df166dc3482508d91f384973823d7"
                use-dev="true"
              ></sw-auth>
              <a href="https://playground.skillwallet.id/" target="blank">
                Redirect to VoiceDAO Playground
              </a>
              <div className="log-cont">
                <h3>
                  Event logs of SkillWallet Contract(Sponsored by Covalent)
                </h3>

                {data?.data?.data?.items.map(item => (
                  <span>{item}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="body">
            <RecommendedUsers />
          </div>
        </div>
      </>
    </StyledDao>
  );
}
InitSwAuth();
const StyledDao = styled(motion.div)`
  display: flex;
  flex-flow: row wrap;

  width: 100%;
  background: ${({ theme_ }) =>
    theme_ ? 'rgb(23, 24, 24,0.9)' : 'rgb(248, 248, 248,0.9)'};
  min-height: 80vh;
  @media screen and (max-width: 900px) {
    position: absolute;
    width: 100%;
    padding-bottom: 15%;
  }
  padding: 2rem;
  .left {
    width: 59%;
    display: flex;
    flex-flow: column wrap;

    h3 {
      font-size: 1.3rem;
      font-weight: 500;
    }
    .body {
      -moz-box-shadow: 0 0 3px #ccc;
      -webkit-box-shadow: 0 0 3px #ccc;
      box-shadow: 0 0 3px #ccc;
      border-radius: 1rem;
      overflow: hidden;
      background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
      .dao-cont {
        display: flex;
        justify-content: center;
        flex-flow: column wrap;
        gap: 1rem;
        align-items: center;
        padding: 4rem;
        a {
          color: #76be02;
        }
      }
    }
    .dp {
      display: none;
    }
    @media screen and (max-width: 900px) {
      width: 100%;
      .dp {
        display: block;
        border-radius: 50%;
        background: grey;
        width: 2rem;
        height: 2rem;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .header {
      position: sticky;
      top: 0;
      padding: 1rem 2rem;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.8)' : 'rgb(255, 255, 255,0.8)'};
      @media screen and (max-width: 900px) {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding: 0.8rem 1rem;
      }
      z-index: 2;
    }
  }
  .right {
    width: 40%;

    display: flex;
    flex-flow: column wrap;
    gap: 1rem;

    padding-left: 2rem;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .posts {
    display: flex;
    flex-flow: column wrap;
    gap: 1rem;
    padding: 1rem 1rem;
    width: 100%;
    @media screen and (max-width: 900px) {
      padding: 0rem 0rem;
      gap: 0rem;
    }
  }
`;
